import SubscribeForm from "../SubscribeForm";

const A = "/brand";

export function BooksCTA() {
  return (
    <section
      data-testid="books-cta-section"
      className="relative w-full overflow-hidden"
      style={{ minHeight: "600px" }}
    >
      <img
        src={`${A}/blueprint4joy-books-coral-sweater-over-shoulder.jpg`}
        alt="Lara laughing over her shoulder, carrying a tall stack of her own books."
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectPosition: "71% 4%" }}
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to right, rgba(28,25,23,0.97) 0%, rgba(28,25,23,0.78) 26%, rgba(28,25,23,0.38) 42%, rgba(28,25,23,0.08) 58%, rgba(28,25,23,0) 70%)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 md:hidden"
        style={{ background: "rgba(28,25,23,0.5)" }}
      />
      <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-20 pb-[43px] md:pb-[54px] min-h-[inherit] flex items-center justify-start">
        <div className="max-w-[420px] reveal text-white translate-y-[75px]">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-white mb-6">
            Want to read what&rsquo;s next?
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-white/90 max-w-lg mb-8">
            Join my newsletter and you&rsquo;ll be the first to hear when
            new books, workshops and ideas find their way into the world.
          </p>
          <div className="max-w-[340px] border-t border-white/20 pt-6">
            <SubscribeForm
              source="books_page"
              testIdPrefix="books-subscribe"
              theme="dark"
              emailButtonGapClassName="gap-1"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
